import { Empty, Label, Loading, Title } from "@components";
import { OlgaEnvironmentsAPI } from "providers/OlgaEnvironmentsAPI";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ForEach, If } from "shared/components/control-statements";
import { InputSearch } from "shared/components/InputSearch";
import styles from "styles/pages/cdp/database-management.module.scss";
import { v4 as uuid } from "uuid";
import CreateGroup from "./CreateGroup";
import Folder from "./Folder";
import Groups from "./Groups";
import MoveItems from "./MoveVariable";
import Variable from "./Variable";

export default function DatabaseManagementSource() {
  const [loading, setLoading] = useState(true);
  const [openGroup, setOpenGroup] = useState(false);
  const [search, setSearch] = useState("");
  const [results, setResults] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [groups, setGroups] = useState([]);
  const [openCreateGroup, setOpenCreateGroup] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      const response =
        await OlgaEnvironmentsAPI.getAllAvailableExternalSourcesConfigs();

      const results = response
        .getData([])
        .filter((item) => item.external_source)
        .map((item) => item.external_source);

      setResults(results);
      setLoading(false);
    };

    fetch();
  }, []);

  if (loading) return <Loading fullContent />;

  const filteredResults = results.filter((c) => {
    return !!search ? c?.toLowerCase().includes(search.toLowerCase()) : true;
  });

  const createGroup = async (group) => {
    setGroups((prev) => [
      ...prev,
      {
        id: uuid(),
        name: group.name,
      },
    ]);

    setSelectedItems([]);
  };

  return (
    <>
      <Title
        title="Origem"
        backTo={{ url: "/cdp/tratamento-de-base", name: "Tratamento de base" }}
      >
        <InputSearch
          placeholder="Buscar por..."
          onChange={(e) => setSearch(e.target.value)}
        />
      </Title>

      <If cond={(groups || []).length > 0}>
        <div className={styles.folders}>
          <ForEach
            items={groups}
            render={(g) => {
              return (
                <Folder
                  key={g.id}
                  folder={g}
                  onSelectFolder={(id) => navigate(`${id}`)}
                />
              );
            }}
          />
        </div>

        <Label>Não tratados</Label>
      </If>

      <If cond={(filteredResults || []).length > 0 && !loading}>
        <div className={styles.results}>
          <ForEach
            items={filteredResults}
            render={(r) => {
              return (
                <Variable
                  key={r}
                  item={r}
                  onSelect={() =>
                    setSelectedItems((prev) =>
                      prev.includes(r)
                        ? prev.filter((id) => id !== r)
                        : [...prev, r]
                    )
                  }
                  icon={<i className="fal fa-arrow-progress" />}
                  selectedItems={selectedItems}
                />
              );
            }}
          />
        </div>
      </If>

      <If cond={(filteredResults || []).length === 0 && !loading}>
        <Empty>
          <i className="fal fa-arrow-progress" />
          <p>Nenhum registro encontrado.</p>
        </Empty>
      </If>

      <If cond={(selectedItems || []).length > 0}>
        <MoveItems
          selectedItems={selectedItems}
          setSelectedItems={setSelectedItems}
          openGroup={() => setOpenGroup(true)}
        />
      </If>

      <Groups
        visible={openGroup}
        onClose={() => setOpenGroup(false)}
        onSave={() => {
          setSelectedItems([]);
        }}
        groups={groups}
        variableName="Origem"
        openCreateGroup={() => setOpenCreateGroup(true)}
      />

      <CreateGroup
        visible={openCreateGroup}
        onClose={() => setOpenCreateGroup(false)}
        onCreateGroup={(group) => createGroup(group)}
      />
    </>
  );
}
